import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://missionmap-lc.onrender.com/api',
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const updateWorkerLocation = (data) =>
  axiosInstance.post('/workerlocation/update', data);

export const getAllLiveLocations = () =>
  axiosInstance.get('/workerlocation/admin/all');

export default axiosInstance;
